import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <iframe
      src="/privacy-policy/policy.html"
      width="100%"
      height="100%"
    ></iframe>
  );
};
